import Hero from "@/components/home/Hero";
import Intro from "@/components/home/Intro";
import Stats from "@/components/home/Stats";
import ServicesPreview from "@/components/home/ServicesPreview";
import PhotoBreak from "@/components/home/PhotoBreak";
import Industries from "@/components/home/Industries";
import SafetySection from "@/components/home/SafetySection";
import WhyPreview from "@/components/home/WhyPreview";
import Expansion from "@/components/home/Expansion";
import Testimonials from "@/components/home/Testimonials";
import CTASection from "@/components/CTASection";
import { MarqueeStrip } from "@/components/motion";
import { MARQUEE_ITEMS } from "@/data/site";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Hero />
      <MarqueeStrip items={MARQUEE_ITEMS} />
      <Intro />
      <Stats />
      <ServicesPreview />
      <PhotoBreak />
      <Industries />
      <SafetySection />
      <WhyPreview />
      <Expansion />
      <Testimonials />
      <CTASection />
    </div>
  );
}
